<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6">
                        <div class="font-weight-bold body-1">
                            Detalle Cuenta PECE
                        </div>
                    </v-col>
                </v-row> 
                <v-row justify="center">
                    <v-col cols="12" md="6" >

                    <details-item :detailsItems="items"></details-item>


                    </v-col>
                    
                </v-row>
                
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" class="d-flex justify-end">
                    
					<primary-button :props="cancelBtnData"></primary-button>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import DetailsItem from '../../../components/DetailsItem.vue';
import Utils from "../../../helpers/Utils";
export default {
    components: {
        DetailsItem
    },
	data(){
		return {
            slug: this.$route.params.slug,
            loading: false,
           
            items: [
            ],
            
           
            cancelBtnData: {
                text: "Regresar",
                icon: "",
                click: () => {this.backPage()}
            },
         
          
		}
    },
    mounted(){
        this.index();
    },
	methods: {
        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.peceAccount.get(this.$store.state.business, this.slug)
			.then((response) => {
                // this.items.forEach((y) => {
                //     y.valor = response.data[y.index]
                // });
                this.items= [
                    { concepto: 'Fecha', index: 'due_date', valor: Utils.globalDateFormat(response.data.payment_date)},
                    { concepto: 'Cliente', index: 'slug', valor: response.data.customer?.name??'' },
                    { concepto: 'Forma de pago', index: 'slug', valor: response.data.payment_method?.name??'' },
                    { concepto: 'Cuenta Bancaria', index: 'slug', valor: `${response.data.bank_account?.name??""} - ${response.data.bank_account?.currency??""}` },
                    { concepto: 'Pedimento', index: 'slug', valor: response.data.pedimento??"" },
                    { concepto: 'Comentarios', index: 'slug', valor: response.data.comments??"" },
                    { concepto: 'Monto', index: 'slug', valor: Utils.currencyFormat(response.data.amount, response.data.bank_account?.currency??"") },

                ];

                if(response.data.file_url != null){
                    this.items.push(
                        {concepto: `Adjunto`, index: 'vaucher', valor: response.data.file_url??null, isFile:true},
                    );
                }

              
                
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},

        backPage()
        {
            
            this.$router.push({name: 'PeceAccounts'});
            
          
        }
       
    },
}
</script>

<style>
    .v-skeleton-loader__text{
        margin-bottom: 0px;
    }
    .pre{
        white-space: pre-line;
    }
</style> 